const Pig = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 150 151"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mx-auto z-10 relative"
  >
    <path
      d="M78.4805 98.0916C78.4805 98.0916 81.5514 106.486 84.8954 108.669C88.2393 110.921 93.4259 109.83 96.0191 108.533C98.6124 107.236 100.591 93.3828 100.591 93.3828L78.4805 98.0916Z"
      fill="#6D9FFF"
    />
    <path
      d="M92.334 101.368C92.334 101.368 94.6543 108.056 97.1793 109.557C99.7043 111.059 106.802 108.056 108.917 105.804C111.033 103.484 112.671 91.5408 111.238 88.6064C109.736 85.6719 92.334 101.436 92.334 101.436V101.368Z"
      fill="#006BF8"
    />
    <path
      d="M58.9626 104.097C58.9626 104.097 61.2829 112.696 64.4222 115.221C67.5614 117.746 72.8161 117.132 75.5459 116.04C78.2757 115.016 81.4149 101.367 81.4149 101.367L58.9626 104.097Z"
      fill="#006BF8"
    />
    <path
      d="M39.2402 98.5703C39.2402 98.5703 40.3321 107.442 43.0619 110.377C45.7916 113.311 51.1147 113.447 53.9809 112.765C56.8471 112.083 61.8972 99.048 61.8972 99.048L39.3085 98.5703H39.2402Z"
      fill="#6D9FFF"
    />
    <path
      d="M128.23 57.6855C126.319 57.276 123.794 56.4571 121.952 55.1605C122.429 54.751 122.907 54.3415 123.248 53.8638C125.364 50.9294 124.955 47.4489 121.201 46.357C117.038 45.1286 116.151 50.5881 117.379 53.3179C117.584 53.7274 117.789 54.1368 117.994 54.478C116.219 55.024 114.24 54.8193 112.398 54.9557C111.783 54.9557 111.374 55.9112 112.056 56.2524C114.24 57.276 117.243 57.3443 119.7 56.4571C121.884 58.3679 125.023 59.3234 127.957 59.4598C128.981 59.4598 129.186 57.9585 128.162 57.7537L128.23 57.6855ZM119.563 50.1104C119.768 48.5408 122.088 49.701 121.679 51.2706C121.474 52.0895 120.86 52.8402 120.246 53.3861C119.7 52.499 119.359 51.4071 119.563 50.1104Z"
      fill="#6D9FFF"
    />
    <path
      d="M32.5522 34.0042C32.5522 34.0042 43.676 33.5947 48.726 40.8968C53.7761 48.2671 42.8571 45.9468 42.8571 45.9468L36.1692 44.036L33.8489 40.4873L32.6205 34.0042H32.5522Z"
      fill="#6D9FFF"
    />
    <path
      d="M42.6525 43.0194C42.6525 43.0194 34.2585 33.8064 32.5524 34.0112C30.8463 34.2159 28.3895 48.2741 28.7989 52.0276C29.2084 55.781 42.6525 43.0194 42.6525 43.0194Z"
      fill="#006BF8"
    />
    <path
      d="M40.1274 44.0401C40.1274 44.0401 35.0091 38.4441 33.9855 38.5806C32.9618 38.7171 31.4604 47.2476 31.6652 49.5678C31.9381 51.8881 40.0592 44.1083 40.0592 44.1083L40.1274 44.0401Z"
      fill="#00143A"
    />
    <path
      d="M23.1347 83.3513C15.4232 64.0383 29.6179 37.2185 69.2676 34.6934C108.917 32.1684 125.91 56.9409 117.516 83.1466C109.122 109.352 38.0119 120.681 23.0665 83.3513H23.1347Z"
      fill="#006BF8"
    />
    <path
      d="M26.8882 77.4112C26.8882 77.4112 26.5469 72.1565 31.7335 68.6078C36.92 65.0591 48.3167 65.878 51.183 70.7234C54.0492 75.5687 45.3822 84.1674 40.6052 83.6214L26.8882 77.4112Z"
      fill="#E5EEFF"
    />
    <path
      d="M26.8882 77.4099C26.8882 84.9849 46.6789 88.0559 46.6789 77.4099C46.6789 66.7638 26.8882 66.4226 26.8882 77.4099Z"
      fill="#006BF8"
    />
    <path
      d="M34.6679 76.6608C34.6679 77.6845 33.7807 78.5717 32.6888 78.5717C31.5969 78.5717 30.7097 77.7527 30.7097 76.6608C30.7097 75.5689 31.5969 74.75 32.6888 74.75C33.7807 74.75 34.6679 75.5689 34.6679 76.6608Z"
      fill="#00143A"
    />
    <path
      d="M42.9254 77.278C42.9254 78.3017 42.0383 79.1888 40.9464 79.1888C39.8545 79.1888 38.9673 78.3699 38.9673 77.278C38.9673 76.1861 39.8545 75.3672 40.9464 75.3672C42.0383 75.3672 42.9254 76.1861 42.9254 77.278Z"
      fill="#00143A"
    />
    <path
      d="M63.808 47.8594C63.0573 45.9486 73.4304 39.056 78.071 40.0796C82.7115 41.1033 83.5305 55.3663 82.2338 57.6866C81.0054 60.0068 67.1519 56.6629 63.7397 47.7912L63.808 47.8594Z"
      fill="#006BF8"
    />
    <path
      d="M82.3021 57.7562C83.5305 55.4359 82.7115 41.1729 78.1392 40.1492C77.6615 40.0128 77.1155 40.0128 76.5696 40.1492L76.9108 40.6269C76.9108 40.6269 79.3676 51.546 78.4804 58.3704C80.4595 58.7116 81.9608 58.5068 82.3703 57.8244L82.3021 57.7562Z"
      fill="#E5EEFF"
    />
    <path
      d="M74.7271 57.2818C75.0683 56.3947 75.273 55.5075 75.3413 54.5521C75.6825 51.3446 74.9318 48.0689 74.1129 44.9297C70.7007 45.9533 67.6297 48.0007 65.3777 50.6622C67.698 53.8014 71.3831 56.0534 74.7271 57.2818Z"
      fill="#00143A"
    />
    <path
      d="M51.456 61.6484C48.112 61.6484 48.112 66.835 51.456 66.835C54.7999 66.835 54.7999 61.6484 51.456 61.6484Z"
      fill="#00143A"
    />
    <path
      d="M34.6679 60.0078C31.3239 60.0078 31.3239 65.1943 34.6679 65.1943C38.0118 65.1943 38.0118 60.0078 34.6679 60.0078Z"
      fill="#00143A"
    />
    <path
      d="M83.7353 36.8096C82.1657 36.0589 80.1184 35.786 78.0711 35.7177C76.0237 35.513 73.8399 35.5812 72.3386 35.5812C69.1311 35.5812 65.5142 35.9907 63.2621 37.8333C62.2385 38.6522 63.2621 40.1536 64.8318 39.8123C68.9946 38.8569 73.3622 38.4475 77.7298 38.584C79.0265 38.584 82.1657 39.4711 83.3258 39.0617C84.486 38.6522 85.2367 37.4921 83.8035 36.8096H83.7353Z"
      fill="#00143A"
    />
    <path
      d="M122.326 32.7888C123.082 33.5086 122.367 34.7596 121.363 34.4733L115.946 32.9285C115.582 32.8247 115.191 32.9354 114.935 33.2144L111.103 37.3975C110.384 38.1826 109.1 37.4481 109.411 36.43L111.072 31.0056C111.183 30.6438 111.08 30.2504 110.806 29.9895L106.726 26.105C105.97 25.3852 106.685 24.1342 107.689 24.4205L113.106 25.9653C113.47 26.0691 113.861 25.9584 114.117 25.6794L117.949 21.4963C118.668 20.7112 119.953 21.4457 119.641 22.4638L117.981 27.8882C117.87 28.25 117.973 28.6434 118.247 28.9043L122.326 32.7888Z"
      fill="#FFA412"
    />
    <path
      d="M25.0022 105.979C25.9265 106.464 25.5814 107.863 24.5376 107.863L22.1556 107.862C21.7772 107.862 21.4312 108.076 21.2618 108.414L20.235 110.466C19.7584 111.418 18.3217 111.063 18.3425 109.999L18.3873 107.705C18.3947 107.327 18.1878 106.977 17.8527 106.801L15.7436 105.694C14.8194 105.209 15.1644 103.81 16.2083 103.81L18.5902 103.811C18.9686 103.811 19.3146 103.597 19.484 103.259L20.5108 101.207C20.9874 100.255 22.4241 100.61 22.4033 101.674L22.3585 103.968C22.3511 104.346 22.5581 104.696 22.8931 104.872L25.0022 105.979Z"
      fill="#FFA412"
    />
  </svg>
);

export default Pig;
